import { SBModel } from '@supplement-bacon/react-toolkit/models'

export interface Role extends SBModel {
  name: keyof typeof roleNameDictionary
  entity: string | null
}

const roleNameNotEditable = ['admin', 'manager', 'visitor']
const isRoleEditable: (role: Role) => boolean = (role) =>
  !roleNameNotEditable.includes(role.name)

const roleNameDictionary = {
  admin: 'Admin',
  marketing: 'Marketing',
  communication: 'Communication',
  'head-of-project': 'Head of Project',
  membership: 'Membership',
  business: 'Business',
  'membership-program-manager': 'Membership Program Manager',
}

export { isRoleEditable, roleNameDictionary, roleNameNotEditable }
